import { render, staticRenderFns } from "./EndSession.vue?vue&type=template&id=6bfd0f1d&"
import script from "./EndSession.vue?vue&type=script&lang=js&"
export * from "./EndSession.vue?vue&type=script&lang=js&"
import style0 from "./EndSession.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports